import React from 'react';
import moment from 'moment';


const ReceivedMsg = ({message}) => {
  return (
    <div className="message-wrap recevied-msg">
      <span className="message-time">
        {moment(message?.created_at).format('dddd, h:mma')}
      </span>
      <div className="message-content">
        <p>{message?.message}</p>
      </div>
    </div>
  );
};

export default ReceivedMsg;
